export default __webpack_public_path__ + "static/media/Image (5).12eb971e.png";